import type { TourDefinition } from '../tours.types';

export const FIRST_CERTIFICATE_HINT_TOUR: TourDefinition = {
  id: 'first_certificate_hint',
  route: '/perfil/perfil',
  remember: true,
  steps: [
    {
      element: '[data-tour="perfil-certificados-title"]',
      popover: {
        title: 'Agrega tu primer certificado',
        description:
          'Para poder firmar documentos necesitas registrar al menos un certificado. En esta sección puedes administrarlos.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="cert-add-btn"]',
      popover: {
        title: 'Agregar certificado',
        description:
          'Haz clic aquí para buscar tu certificado por scratchcard/usuario y autocompletar los datos.',
        side: 'left',
        align: 'center',
      },
    },
  ],
};
